export const homeObjOne7 = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDes: true,
    topLine: 'Prestige Event & Catering ',
    headline: 'Kostnadsfri konsultation',
    description: 'Er vision. Vår expertis. En upplevelse utöver det vanliga. Vi erbjuder en personlig och kostnadsfri konsultation där vi tillsammans formar varje detalj kring ert event. Från exklusiva menyer och professionell personal till lokal, dekor och helhetsplanering – allt skräddarsys med omsorg efter era önskemål. Ni drömmer – vi skapar upplevelsen.',
    imgStart: false,
    img: require('../../AssetsForDecore/inredning.jpg'),
    alt: 'catering',
    dark: true,
    primary: true,
    darkText: false,
}